<template>
  <div
    @keyDown.prevent="onKeyDown()"
    class="
      overlay
      overlay--opened
    "
    >
    <div
      class="
        color/background
        layout/fixed
        layout/height
        layout/scroll:vertical
        layout/width:100%
      "
      :class="['has-dark-background']"
      style="
        --layout--height: calc(1 * var(--visible-height) - 0rem);
        --color--background: rgba(25, 25, 25, 0.96);
      "
      >
      <div
        class="
          @480/layout/flex:row
          @480/layout/margin:top:page
          @480/layout/padding:left
          @480/layout/padding:right
          @480/layout/margin:left
          @480/layout/margin:right
          layout/flex:column
          layout/width
          layout/width:max
        "
        :class="spinnerClass"
        style="
          --480--layout--padding--left: var(--page-spacing--fixed);
          --480--layout--padding--right: var(--page-spacing--fixed);
          --480--layout--margin--left: auto;
          --480--layout--margin--right: auto;
          --layout--width--max: var(--page-width--maximum);
          --layout--width: var(--page-width--visible);
          --picture--max-height: var(--hero--height--image--ceiling);
        "
        >
        <div
          class="
            @480/layout/order:1
            layout/order:2
            ratio-container
          "
          >
          <div class="ratio-container__16-9"></div>
          <div class="ratio-container__inner">
            <div
              id="vimeo-player-mount"
              data-vimeo-responsive="true"
              class="layout/width:100%"
            />
          </div>
        </div>

        <div
          class="
            @480/layout/align:start
            @480/layout/order:2
            @480/layout/padding:bottom:clear
            @480/layout/padding:left:page
            @480/layout/padding:right:clear
            @480/layout/padding:top:clear
            @768/layout/padding:left:page:0.5
            layout/flex
            layout/justify:end
            layout/order:1
            layout/padding:page
          "
          >
          <a
            @click.prevent="$emit('close')"
            :aria-label="label"
            :title="label"
            data-gtm="overlay topic item detail / close"
            class="$color/focus:reverse link/focus"
            href="#"
            role="button"
            v-html="closeSvg"
          />
        </div>
      </div>

      <section class="layout/wrapper">
        <div class="uneven-columns__first" />
        <div class="uneven-columns__second">
          <div
            class="
              $color/white
              layout/padding:bottom:page:2
            "
            >
            <div
              class="
                $typography/size:medium
                layout/flex:column
                layout/margin:top:page
              "
              >
              <p
                class="
                  typography
                  typography/truncate:2
                "
                v-html="this.artist"
                />
                <p
                class="
                  $typography/weight:regular
                  typography/truncate:2
                  typography
                "
                v-html="this.title"
                />
                <p
                class="
                  $typography/weight:regular
                  typography/truncate:2
                  typography
                "
                v-html="this.displayDate"
                />
            </div>
            <div
              class="
                $color/white
                $typography/baseline:body
                $typography/size:medium
                $typography/weight:regular
              "
              v-if="this.captionRemainder || this.extendedDescription"
              >
              <p
                class="
                  $typography/scale:down
                  layout/margin:top:baseline
                  typography
                "
                v-if="this.captionRemainder"
                v-html="this.captionRemainder" />
              <p
                class="
                  layout/margin:top:baseline
                  typography
                "
                v-if="this.extendedDescription"
                v-html="this.extendedDescription" />
            </div>
          </div>
        </div>
        <div class="uneven-columns__third" />
      </section>
    </div>
  </div>
</template>

<script>
  import { embedSVG } from 'Helpers/embedSVG';
  import { MoMABalanceText } from 'sol';
  import keyCodes from "../../utils/key-codes.js";
  import trapTab from "../../utils/tab-trapper.js";
  import VimeoPlayer from '@vimeo/player';

  export default {
    props: {
      itemId: {type: Number, required: true},
    },

    data: function() {
      return {
        artist: "",
        balanceText: new MoMABalanceText(),
        captionRemainder: "",
        displayDate: "",
        extendedDescription: "",
        isOverlayLoading: true,
        title: "",
        videoLoaded: false,
        vimeoEmbedId: "",
      };
    },

    created() {
      this.fetchChannelItem();
      window.addEventListener('keydown', this.onKeyDown);
    },

    destroyed() {
      window.removeEventListener('keydown', this.onKeyDown);
    },

    mounted() {
      window.MoMA.ScrollManager.preventScroll(this.$el);
      this.$el.querySelector("a").focus();
    },

    computed: {
      spinnerClass() {
        if (this.videoLoaded) {
          return "spinner";
        }
        return "spinner spinner--visible";
      },
      closeSvg() {
        return embedSVG("icon__x--24--stroke.svg", "controls__link__svg--close");
      },
      label() {
        return "Close overlay"
      },
    },

    methods: {
      fetchChannelItem: async function () {
        const url = `/calendar/channels/item/${this.itemId}.json`;
        await fetch(url)
          .then(res => res.json())
          .then(res => {
            this.artist = res.Artist;
            this.captionRemainder = res.CaptionRemainder;
            this.displayDate = res.DisplayDate;
            this.extendedDescription = res.ExtendedDescription;
            this.title = res.Title;
            this.vimeoEmbedId = res.VimeoEmbedId;
          })
          .then(res => {
            this.updateHistory();
            this.isOverlayLoading = false;
            this.videoLoaded = true;

            this.vimeoPlayer = new VimeoPlayer('vimeo-player-mount', {
              id: this.vimeoEmbedId,
            }).play();
          })
          .catch(error => {
            console.log(url + ' failed with error: ', error);
          });
      },
      updateHistory() {
        const params = new URLSearchParams(location.search);
        params.set("item_id", this.itemId);

        window.history.replaceState({
          itemId: this.itemId,
        }, "", `${location.pathname}?${params}`);
      },
      onKeyDown(event) {
        switch (event.keyCode) {
          case keyCodes.ESCAPE:
            return this.$emit('close');
          case keyCodes.TAB:
            return trapTab(this.$el, event);
        }
      },
    }
  };
</script>
